'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _isImmutable = require('../util/isImmutable');

var _isImmutable2 = _interopRequireDefault(_isImmutable);

var _isRecord = require('../util/isRecord');

var _isRecord2 = _interopRequireDefault(_isRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getName = function getName(name) {
    return name ? name + '()' : 'function';
};

var noMethodError = function noMethodError(name) {
    throw new Error('Evaluation of ' + getName(name) + ' failed: method doesn\'t exist');
};

exports.default = function (config) {
    var immutable = config.immutable;


    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return function (item) {
            if ((0, _isRecord2.default)(item)) {
                return callRecord(config, args, item);
            }
            if ((0, _isImmutable2.default)(item)) {
                return callImmutable(config, args, item);
            }
            if (Array.isArray(item)) {
                return callArray(config, args, item);
            }
            if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === "object") {
                return callObject(config, args, item);
            }
            throw new Error('Evaluation of ' + getName(immutable) + ' failed: Value is invalid ' + item);
        };
    };
};

var callImmutable = function callImmutable(_ref, args, item) {
    var immutable = _ref.immutable,
        all = _ref.all;

    if (immutable) {
        if (!item[immutable]) {
            noMethodError(immutable);
        }
        return item[immutable].apply(item, _toConsumableArray(args));
    }
    if (all) {
        return all.apply(undefined, _toConsumableArray(args))(item);
    }
    noMethodError(immutable);
};

var callRecord = function callRecord(_ref2, args, item) {
    var immutable = _ref2.immutable,
        record = _ref2.record,
        keyed = _ref2.keyed,
        all = _ref2.all;

    if (record) {
        if (typeof record === 'string') {
            return item[record].apply(item, _toConsumableArray(args));
        }
        return record.apply(undefined, _toConsumableArray(args))(item);
    }
    if (keyed) {
        return keyed.apply(undefined, _toConsumableArray(args))(item);
    }
    if (all) {
        return all.apply(undefined, _toConsumableArray(args))(item);
    }
    noMethodError(immutable);
};

var callArray = function callArray(_ref3, args, item) {
    var immutable = _ref3.immutable,
        array = _ref3.array,
        all = _ref3.all;

    if (array) {
        return array.apply(undefined, _toConsumableArray(args))(item);
    }
    if (all) {
        return all.apply(undefined, _toConsumableArray(args))(item);
    }
    noMethodError(immutable);
};

var callObject = function callObject(_ref4, args, item) {
    var immutable = _ref4.immutable,
        keyed = _ref4.keyed,
        object = _ref4.object,
        all = _ref4.all;

    if (object) {
        return object.apply(undefined, _toConsumableArray(args))(item);
    }
    if (keyed) {
        return keyed.apply(undefined, _toConsumableArray(args))(item);
    }
    if (all) {
        return all.apply(undefined, _toConsumableArray(args))(item);
    }
    noMethodError(immutable);
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/internal/prep.js
// module id = 131
// module chunks = 35783957827783 107818501498521